import { PktLoader } from '../components/loader/Loader'

export default function Loader() {
  return (
    <main className="page-main pkt-container">
      <h1>Loader</h1>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '1rem' }}>
        <section className="component ">
          <h2>Variant "small"</h2>
          <p>Rainbow (default), blue and shapes</p>
          <PktLoader size="small" variant="blue" />
          <PktLoader message="Laster inn.." size="small" variant="blue" />
          <PktLoader message="Laster inn.." size="small" variant="rainbow" />
          <PktLoader size="small" variant="rainbow" />
          <PktLoader message="Laster inn.." size="small" variant="shapes" />
          <PktLoader size="small" variant="shapes" />
        </section>
        <section className="component">
          <h2>Variant "medium" (default)</h2>
          <p>Rainbow (default), blue and shapes</p>
          <PktLoader message="Laster inn.." size="medium" variant="blue" />
          <PktLoader size="medium" variant="blue" />
          <PktLoader message="Laster inn.." size="medium" variant="rainbow" />
          <PktLoader size="medium" variant="rainbow" />
          <PktLoader message="Laster inn.." size="medium" variant="shapes" />
          <PktLoader size="medium" variant="shapes" />
        </section>
        <section className="component">
          <h2>Variant "large" </h2>
          <p>Rainbow (default), blue and shapes</p>
          <PktLoader message="Laster inn.." size="large" variant="blue" />
          <PktLoader size="large" variant="blue" />
          <PktLoader message="Laster inn.." size="large" variant="rainbow" />
          <PktLoader size="large" variant="rainbow" />
          <PktLoader message="Laster inn.." size="large" variant="shapes" />
          <PktLoader size="large" variant="shapes" />
        </section>
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '1rem' }}>
        <section className="component">
          <h2>With delay</h2>
          <p>1000ms</p>
          <PktLoader message="Laster inn.." size="large" variant="blue" delay={1000} />
          <p>2500ms</p>
          <PktLoader message="Laster inn.." size="large" variant="rainbow" delay={2500} />
          <p>5000ms</p>
          <PktLoader message="Laster inn.." size="large" variant="shapes" delay={5000} />
        </section>
        <section className="component">
          <h2>
            Inline <PktLoader size="small" variant="rainbow" inline />
          </h2>
          <PktLoader message="Laster inn.." size="large" variant="blue" inline />
          <PktLoader size="large" variant="blue" inline />
          <PktLoader message="Laster inn.." size="large" variant="rainbow" inline />
          <PktLoader size="large" variant="rainbow" inline />
          <PktLoader message="Laster inn.." size="large" variant="shapes" inline />
          <PktLoader size="large" variant="shapes" inline />
        </section>
      </div>
    </main>
  )
}
